"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var helpers_1 = require("../../../helpers");
var style_1 = require("../style");
var IcAwardLeft_1 = __importDefault(require("./IcAwardLeft"));
var IcAwardRight_1 = __importDefault(require("./IcAwardRight"));
var style_2 = require("./style");
var Awards = function (_a) {
    var awards = _a.awards, title = _a.title;
    return (react_1.default.createElement(style_2.Wrapper, null,
        react_1.default.createElement(style_1.ColumnTitle, null, title),
        awards.map(function (award, i) { return (react_1.default.createElement("div", { className: 'MainSection__Awards', key: i + "-" + award },
            react_1.default.createElement(IcAwardLeft_1.default, null),
            react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: helpers_1.nlToBr(award) } }),
            react_1.default.createElement(IcAwardRight_1.default, null))); })));
};
exports.default = Awards;
